import { CompanyMenusData } from '../exports/Interfaces';

/**
 * Puts the counts from the likes endpoint on the menu's products. The menu itself no longer carries
 * them; if the likes request failed, a product keeps whatever count it has, or 0.
 */
export default function withLikeCounts(
  menus: CompanyMenusData,
  likes: Record<string, number> | null,
): CompanyMenusData {
  if (!menus?.products) {
    return menus;
  }

  return {
    ...menus,
    products: Object.fromEntries(
      Object.entries(menus.products).map(([id, product]) => [
        id,
        { ...product, likes_count: likes ? (likes[id] ?? 0) : (product.likes_count ?? 0) },
      ]),
    ),
  };
}
